import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PageId, PageType } from "@/types/page";

const usePage = () => {
  const location = useLocation();

  const [pageId, setPageId] = useState<PageId>();
  const [pageType, setPageType] = useState<PageType>();

  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      const id = params.get("pageId") as PageId;

      const pageTypeMap: {
        [key in string]: PageType
      } = {
        [PageId.SALE_NOT_PASS]: PageType.SALE,
        [PageId.SALE_OFFICIAL]: PageType.SALE,
        [PageId.SALE_CUSTOMER]: PageType.SALE,

        [PageId.MC_NOT_PASS]: PageType.MATERIAL_CONTROL,
        [PageId.MC_PASSED]: PageType.MATERIAL_CONTROL,
        [PageId.MC_BE_REJECT]: PageType.MATERIAL_CONTROL,
        [PageId.MC_OFFICIAL_CLOSED]: PageType.MATERIAL_CONTROL,
        [PageId.MC_OFFICIAL_DONE]: PageType.MATERIAL_CONTROL,
        [PageId.MC_OFFICIAL_PENDING]: PageType.MATERIAL_CONTROL,
        [PageId.MC_BOM]: PageType.MATERIAL_CONTROL,
        [PageId.MC_REQ_MANAGE]: PageType.MATERIAL_CONTROL,
        [PageId.MC_REQ_M]: PageType.MATERIAL_CONTROL,

        [PageId.COMMODITY_NOT_PASS]: PageType.COMMODITY,
        [PageId.COMMODITY_PASSED]: PageType.COMMODITY,
        [PageId.COMMODITY_BE_REJECT]: PageType.COMMODITY,
        [PageId.COMMODITY_OFFICIAL_PENDING]: PageType.COMMODITY,
        [PageId.COMMODITY_OFFICIAL_DONE]: PageType.COMMODITY,
        [PageId.COMMODITY_OFFICIAL_CLOSED]: PageType.COMMODITY,
        [PageId.COMMODITY_ENTER_DATA]: PageType.COMMODITY,
        [PageId.COMMODITY_DATA_MT]: PageType.COMMODITY,

        [PageId.PROD_NOT_PASS]: PageType.PROD,
        [PageId.PROD_PASSED]: PageType.PROD,
        [PageId.PROD_BE_REJECT]: PageType.PROD,
        [PageId.PROD_OFFICIAL_CLOSED]: PageType.PROD,
        [PageId.PROD_OFFICIAL_DONE]: PageType.PROD,
        [PageId.PROD_OFFICIAL_PENDING]: PageType.PROD,
        [PageId.PROD_ENTER_DATA]: PageType.PROD,
        [PageId.PROD_DATA_MT]: PageType.PROD,
        [PageId.PROD_MATERIAL_OVER_ISSUE]: PageType.PROD,

        [PageId.PUR_NOT_PASS]: PageType.PURCHASE,
        [PageId.PUR_PASSED]: PageType.PURCHASE,
        [PageId.PUR_BE_REJECT]: PageType.PURCHASE,
        [PageId.PUR_ALL_QUTATION]: PageType.PURCHASE,
        [PageId.PUR_OFFICIAL_PENDING]: PageType.PURCHASE,
        [PageId.PUR_OFFICIAL_DONE]: PageType.PURCHASE,
        [PageId.PUR_OFFICIAL_CLOSED]: PageType.PURCHASE,
        [PageId.PUR_ORDER_PENDING_PAY]: PageType.PURCHASE,
        [PageId.PUR_ORDER_PAYED]: PageType.PURCHASE,
        [PageId.PUR_ORDER_DONE]: PageType.PURCHASE,
        [PageId.PUR_HELP_ACCEPT]: PageType.PURCHASE,
        [PageId.PUR_ALL_PASSED]: PageType.PURCHASE,
        [PageId.PUR_SUPPLIER]: PageType.PURCHASE,

        [PageId.F_NOT_PASS]: PageType.FINANCE,
        [PageId.F_PASSED]: PageType.FINANCE,
        [PageId.F_BE_REJECT]: PageType.FINANCE,
        [PageId.F_SALE_OFFICIAL]: PageType.FINANCE,
        [PageId.F_OFFICIAL_CLOSED]: PageType.FINANCE,
        [PageId.F_OFFICIAL_DONE]: PageType.FINANCE,
        [PageId.F_OFFICIAL_PENDING]: PageType.FINANCE,
      }

      id && setPageId(id)
      setPageType(pageTypeMap[id] || undefined)
    }
  }, [location.search]);

  return {pageId, pageType};
};

export default usePage;
